import GenericDB from './generic-db';

export default class TreatmentServicesDB extends GenericDB {
  constructor() {
    super('treatmentServices');
  }

  // Clinic-scoped by a `clinic` field: callers filter reads with a
  // ['clinic', '==', clinicId] constraint and set `clinic` on writes.
}
